import React, { useContext, useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import Modal from 'react-bootstrap/Modal';
import ConsultasFormularios from '../Sql/ConsultasFormularios';
import UtilsBufer from '../Tools/UtilsBufer';
import DateConverter from '../Tools/DateConverter';
import ContenidoFormulario from './ContenidoFormulario';
import { ContextGloball } from '../Context/ContextGlobal';
import xlsx from 'sheetjs-style'
import * as FileSaver from 'file-saver'

function RespuestaFormularios(props) {
    const { setLoading } = useContext(ContextGloball);
    const { selectFormulario, infoUser, selectEmpleado } = props;
    const [listaRespuestas, setListaRespuestas] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectRespuesta, setSelectRespuesta] = useState(null);
    const [preguntas, setPreguntas] = useState([]);
    const obtenerRespuestas = async () => {
        try {
            var respuestas = await ConsultasFormularios.obtenerRespuestasFormulario(
                {
                    'regional': infoUser.regional, 'ID_EMPLEADO': selectEmpleado.ID_EMPLEADO,
                    'ID_FORMULARIO': selectFormulario.ID_FORMULARIO
                }
            );
            if (respuestas.ok) {
                setListaRespuestas(respuestas.ok);
            } else {
                MsgUtils.msgError(respuestas.error);
            }
        } catch (error) {
            MsgUtils.msgError(error.message);
        }
    }
    const obtenerPreguntas = async () => {
        try {
            var respuestas = await ConsultasFormularios.obtenerPreguntasFormulario(
                {
                    'regional': infoUser.regional, "ID_ENCUESTA": selectFormulario.ID_ENCUESTA
                }
            );
            if (respuestas.ok) {
                setPreguntas(respuestas.ok);
            } else {
                MsgUtils.msgError(respuestas.error);
            }
        } catch (error) {
            MsgUtils.msgError(error.message);
        }
    }
    async function exportarExcel() {
        var datosExcel = [];
        for (var res of listaRespuestas) {
            var obj = {
                "RESPONDIO": res.NOMBRE_RESP,
                "CARGO QUE RESPONDIO": res.CARGO_RESP,
                "ENCUESTA": selectFormulario.TITULO,
                "NOMBRE": res.NOMBREX,
                "AREA": res.AREA,
                "CARGO": res.CARGO
            }
            getRespuestaUsuario(obj, res.RESPUESTA)
            datosExcel.push(obj)
        }
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        const fileExtencion = '.xlsx';
        const ws = xlsx.utils.json_to_sheet(datosExcel);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = xlsx.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        var fechaDescarga = new Date()
        FileSaver.saveAs(data, `RespuestasFormularios_${fechaDescarga.toISOString().substring(0, 10)}` + fileExtencion);
    }
    function getRespuestaUsuario(obj, datos) {
        for (var preg of preguntas) {
            var info = datos.filter((item) => item.ID_PREGUNTA === preg.ID_PREGUNTA);
            if (info.length != 0) {
                if (preg.TIPO === 'S') {
                    obj[UtilsBufer.getText(preg.DESCRIPCION)] = UtilsBufer.getText(info[0].NOMBRE_OPCION);
                } else if (preg.TIPO === 'M') {
                    var auxf = info.filter((item) => item.ID_OPCION != 0);
                    var respp = ''
                    for (var item of auxf) {
                        respp += UtilsBufer.getText(item.NOMBRE_OPCION) + ' ; ';
                    }
                    obj[UtilsBufer.getText(preg.DESCRIPCION)] = respp.slice(0, -2);
                } else if (['R', 'F', 'H'].includes(preg.TIPO) == true) {
                    obj[UtilsBufer.getText(preg.DESCRIPCION)] = UtilsBufer.getText(info[0].DESCRIPCION);
                } else if (preg.TIPO == 'O') {
                    var resp = ''
                    var filtroInfo = info.filter(item => item.ID_OPCION != 0);
                    for (var item of filtroInfo) {
                        resp += UtilsBufer.getText(item.NOMBRE_OPCION) + ':' + UtilsBufer.getText(item.DESCRIPCION) + ' ; '
                    }
                    obj[UtilsBufer.getText(preg.DESCRIPCION)] = resp.slice(0, -2);
                }
            } else {
                obj[UtilsBufer.getText(preg.DESCRIPCION)] = '';
            }
        }
    }
    useEffect(() => {
        obtenerRespuestas();
        obtenerPreguntas();
    }, [])
    return (
        <>
            <div className='container-fluid bg-dark '>
                <div className='row row-cols g-1'>
                    <div className='col-10'>
                        <div className=' text-center text-light fw-bold'>Respuestas del formulario</div>
                    </div>
                    <div className='col-2'>
                        <button className='btn btn-sm btn-success w-100' onClick={() => exportarExcel()}
                            data-bs-toggle="tooltip" data-bs-placement="top"
                            title="Exportar a Excel"><i className="fa-solid fa-file-excel"></i> EXCEL</button>
                    </div>
                </div>
            </div>
            <div className='table-responsive'>
                <table className="table table-sm table-hover table-striped table-dark" id="respuestasColaborado">
                    <thead>
                        <tr>
                            <th scope="col">Responde</th>
                            <th scope="col">Fecha</th>
                            <th style={{ width: '100px' }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {listaRespuestas.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <th>
                                        <div className="card bg-transparent flex-row m-0 p-0" style={{ border: 'none' }} >
                                            {UtilsBufer.getFotoCard(item.FOTO, 40)}
                                            <div className='ps-2 my-auto'>
                                                <div className="cargoHeader fw-bold" id='buscareAqui'>{item.NOMBRE_RESP}</div>
                                                <div className='cargoHeader '>{item.CARGO_RESP}</div>
                                            </div>
                                        </div>
                                    </th>
                                    <td>
                                        <div className='lh-sm'>
                                            <div>{DateConverter.formatoFecha(item.FECHA)}</div>
                                            <div>Hora: {DateConverter.formatoHoraSinSegu(item.FECHA)}</div>
                                        </div>
                                    </td>
                                    <td className=''>
                                        <button className='btn btn-sm btn-secondary w-100'
                                            title='Ver Respuesta del colaborador'
                                            onClick={() => { setSelectRespuesta(item); setShowModal(true); }}>
                                            <i className="fa-solid fa-eye "></i> Ver
                                        </button>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            <Modal show={showModal} onHide={() => setShowModal(false)}
                size="xl" backdrop="static"
                keyboard={false} centered
                aria-labelledby="contained-modal-title-vcenter"
                contentClassName='bg-dark bg-gradient'>
                <Modal.Body bsPrefix='modal-body m-0 p-0'>
                    <ContenidoFormulario selectItem={selectFormulario} setVentana={() => { setShowModal(false) }}
                        regional={infoUser.regional} soloVer={true}
                        setLoader={setLoading} selectRespuesta={selectRespuesta} setSelectRespuesta={setSelectRespuesta}
                        setVerRespuesta={() => { }} />
                </Modal.Body>
            </Modal>
        </>
    )
}

export default RespuestaFormularios